module.exports = __webpack_public_path__ + "img/VX.9fa3a17b.png";